var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnosisWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28308 10.9058C7.67691 10.9058 8.04048 10.7746 8.33335 10.5474L5.92981 8.14478C5.70258 8.43248 5.57131 8.79591 5.57131 9.19467C5.56625 10.1386 6.33378 10.9058 7.28308 10.9058Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4329 9.18955C14.4329 8.79585 14.3017 8.43241 14.0744 8.13965L11.6709 10.5423C11.9587 10.7694 12.3223 10.9007 12.7212 10.9007C13.6654 10.9057 14.4329 10.1385 14.4329 9.18955Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6453 6.58008L14.5798 7.64511C14.9333 8.06911 15.1454 8.60418 15.1454 9.19978C15.1454 10.5374 14.0597 11.6226 12.7216 11.6226C12.1309 11.6226 11.5906 11.4106 11.1664 11.0573L9.99999 12.2233L8.83356 11.0573C8.40942 11.4106 7.87416 11.6226 7.27832 11.6226C5.94022 11.6226 4.85462 10.5374 4.85462 9.19978C4.85462 8.60921 5.06669 8.06911 5.42016 7.64511L4.87479 7.09998L4.35472 6.58008C3.74879 7.57951 3.40039 8.74551 3.40039 9.99731C3.40039 13.6416 6.35429 16.5894 9.99492 16.5894C13.6356 16.5894 16.5895 13.6366 16.5895 9.99731C16.5996 8.74044 16.2512 7.57444 15.6453 6.58008Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7716 5.44417C13.5749 4.18734 11.8783 3.3999 9.99994 3.3999C8.12154 3.3999 6.42997 4.18734 5.22821 5.44417C5.06664 5.6158 4.91011 5.7975 4.76367 5.98427L9.99487 11.2136L15.2261 5.97924C15.0948 5.7975 14.9383 5.61074 14.7716 5.44417ZM9.99994 4.258C11.5451 4.258 12.9791 4.8536 14.0546 5.93884L9.99994 9.99204L5.94524 5.93884C7.0258 4.8536 8.4548 4.258 9.99994 4.258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosisWhite);
export default __webpack_public_path__ + "static/media/gnosis-white.aeb51168d44a85ee2b796f4249ee2471.svg";
export { ForwardRef as ReactComponent };